import { put } from 'redux-saga/effects';

import { ResetPasswordActions } from '@maggie/store/reset-password/actions';

export function* handleDidNavigateToResetPassword(email: string, token: string) {
  if (!!email && !!token) {
    yield put(ResetPasswordActions.setParams(email, token));
  }
}
